module.exports = __webpack_public_path__ + "media/mypage/images/jisseki/jisseki17_pc-8bf24e0255ed4659c8d0ce6234b4ec46.jpg";